<app-main-container>
  <div class="flex flex-1 justify-content-center align-items-center">
    <form (submit)="login()" [formGroup]="loginFG" class="flex flex-column align-items-center">
      <header class="py-6 flex w-full justify-content-center">
        <h2 class="text-center">Connexion à votre compte</h2>
      </header>
      <div class="flex flex-column">
        <div class="p-3">
          <p-floatlabel  variant="on">
            <input formControlName="email" pInputText id="over_label" autocomplete="off" />
            <label for="over_label">Email</label>
          </p-floatlabel>
          <!--Message d'erreur-->
          <div class="min-h-0 h-1rem">
            <p-message  class="p-message" severity="error" text="Email obligatoire"
            *ngIf="loginFG.get('email')?.touched && loginFG.get('email')?.errors?.['required']">
            </p-message>
          </div>
        </div>

        <div class="p-3">
          <p-floatlabel  variant="on">
              <input formControlName="password" type="password" pInputText id="over_label" autocomplete="off" />
              <label for="over_label">Mot de passe</label>
          </p-floatlabel>
           <!--Message d'erreur-->
          <div class="min-h-0 h-1rem">
            <p-message  class="p-message" severity="error" text="Mot de passe obligatoire"
            *ngIf="loginFG.get('password')?.touched && loginFG.get('password')?.errors?.['required']">
            </p-message>
          </div>
        </div>
      </div>
      <p-button type="submit" class="p-5" label="Se connecter" [raised]="true" severity="success" />
    </form>
  </div>
</app-main-container>
